var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-page-wrapper"},[_c('IphoneVideo',{attrs:{"video-name":require('@/assets/videos/group_device_control.mp4')}}),_c('div',{staticClass:"video-page-texts"},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t("pages.group-devices.subtitle1")))]),_c('p',[_vm._v(_vm._s(_vm.$t("pages.group-devices.text1")))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }